import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

type ElementBase = { [key: string]: any };

interface Props<T extends ElementBase, IdType> {
	width?: string | undefined;
	placeholder?: string;
	elements: T[];
	value: IdType | null;
	id: keyof T;
	allowClear?: boolean;
	search: (input: string, element: T) => boolean;
	onChange: (id: IdType) => void;
	buildElement: (element: T) => any;
}

function SearchSelector<T extends ElementBase, IdType>({
	placeholder,
	elements,
	value,
	id,
	allowClear,
	search,
	onChange,
	buildElement,
	width,
}: Props<T, IdType>) {
	const selectedElement = elements?.find((element: T) => element[id] == value);
	const options = elements?.map((element: T) => {
		return (
			<Option key={element[id] ?? 'undefined'} value={element[id]}>
				{buildElement(element)}
			</Option>
		);
	});

	return (
		<Select
			size="large"
			showSearch
			allowClear={allowClear ?? false}
			placeholder={placeholder}
			style={{ width: width ?? 'auto' }}
			value={selectedElement && buildElement(selectedElement)}
			onChange={(id) => onChange(id)}
			optionFilterProp="children"
			filterOption={(input, option) => {
				const element = elements?.find((el) => el[id] == option?.value);
				if (!search || !element) {
					return `${option?.children}`.toLocaleLowerCase().includes(input.toLocaleLowerCase());
				}

				return search(input, element);
			}}
			filterSort={(optionA, optionB) =>
				`${optionA.children}`.toLocaleLowerCase().localeCompare(`${optionB.children}`.toLocaleLowerCase())
			}
		>
			{options}
		</Select>
	);
}

export default SearchSelector;
